import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=537528e1&scoped=true"
import script from "./InputCurrency.vue?vue&type=script&lang=js"
export * from "./InputCurrency.vue?vue&type=script&lang=js"
import style0 from "./InputCurrency.vue?vue&type=style&index=0&id=537528e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537528e1",
  null
  
)

export default component.exports